import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
// import Badge from '@mui/material/Badge';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import dotenv from 'react-dotenv';
import DiseaseList from "./DiseaseList";
import DengueSetting from '../setting/DengueSetting/DengueSetting';
import { useDispatch, useSelector } from 'react-redux';
import { getDisease } from '../../reducer/diseaseSlice';
import MalariaSetting from '../setting/MalariaSetting';
import { Avatar, Button, Divider, Drawer, FormControl, InputLabel, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Menu, MenuItem, Select, SwipeableDrawer, Typography, createTheme } from '@mui/material';
import { getIAAM } from '../../reducer/iaamSlice';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Suspense, useEffect, useState } from 'react';
import { getProfile } from '../../reducer/profileSlice';
import { CardBody, CardFooter, CardHeader, ThemeProvider } from '@material-tailwind/react';
import { getProvinceData } from '../../reducer/areaDataSlice';
import { getMapDataSelected, setMapDataSelected } from '../../reducer/mapDataSelectedSlice';
import DataShow from '../map/DataShow';
import { Apps } from '@mui/icons-material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

let drawerWidth = 320;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            [theme.breakpoints.up("sm")]: {
                marginLeft: 0,
            },
        }),
    }),
);

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        [theme.breakpoints.up("sm")]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: `${drawerWidth}px`,
        },
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

function Layout() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const mapDataSelected = useSelector(getMapDataSelected);
    const provinceData = useSelector(getProvinceData);
    const disease = useSelector(getDisease);
    const profile = useSelector(getProfile);
    const iaam = useSelector(getIAAM);
    const [open, setOpen] = useState(true);
    const [openShowData, setOpenShowData] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [appsAnchorEl, setAppsAnchorEl] = useState(null);
    const { pathname } = useLocation();
    // console.log(pathname);
    const [page, setPage] = useState(pathname);

    let settingMenu;
    if (disease === "1") {
        settingMenu = <DengueSetting />
    } else if (disease === "2") {
        settingMenu = <MalariaSetting />
    }

    useEffect(() => {
        // console.log(profile);
        if (provinceData.length === 0 || profile.apps === undefined) {
            localStorage.setItem("loading", pathname);
            navigate('/');
        }
    }, [provinceData, pathname, profile, navigate]);

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleApps = (event) => {
        setAppsAnchorEl(event.currentTarget);
    };

    const handleAppsClose = (event) => {
        setAppsAnchorEl(null);
    };

    useEffect(() => {
        if (Object.keys(mapDataSelected).length !== 0) {
            setOpenShowData(true);
        }
    }, [mapDataSelected])

    // useEffect(() => {
    //     // console.log(profile);
    //     if (profile === undefined) {

    //     }
    // }, [profile])

    const drawerItem = (
        <div className='overflow-hidden bg-gradient-to-tr from-blue-50 via-gray-100 to-slate-50'>
            <DrawerHeader className='flex items-center justify-between p-4'>
                <Typography variant="h5" color="blue-gray" className="font-primary">
                    ตั้งค่า
                </Typography>
                <IconButton
                    onClick={toggleDrawer}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={2}
                        stroke="currentColor"
                        className="h-5 w-5"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>

                </IconButton>
            </DrawerHeader>
            <div className='px-4'>
                <FormControl fullWidth size='small' sx={{
                    marginBottom: '10px'
                }}>
                    <InputLabel id="theme-morbidity-rate-select-label">รูปแบบการแสดงผล</InputLabel>
                    <Select
                        labelId="theme-morbidity-rate-select-label"
                        id="theme-morbidity-rate-select"
                        value={page}
                        label="รูปแบบการแสดงผล"
                        onChange={(event) => {
                            setPage(event.target.value);
                            navigate(event.target.value);
                        }}
                    >
                        <MenuItem value={"/monitor/map"}>แผนที่</MenuItem>
                        <MenuItem value={'/monitor/table'}>ตาราง</MenuItem>
                        {
                            disease === '1' ?
                                <MenuItem value={'/monitor/tableindex'}>ตารางการสำรวจลูกน้ำยุงลาย</MenuItem> : <></>
                        }
                    </Select>
                </FormControl>
                {settingMenu}
            </div>
            {/* <div className="px-4 mb-6 mt-2">
                <FormControl className="w-full">
                    <InputLabel id="report-select-label" className="font-primary">รายงาน</InputLabel>
                    <Select
                        labelId="report-select-label"
                        id="report-select"
                        value={page}
                        label="รายงาน"
                        size="small"
                        onChange={handleReportChange}
                        className="font-primary"
                        MenuProps={{
                        sx: {
                            "&& .Mui-selected": {
                                backgroundColor: "#b73238",
                                color: "#fff"
                            },
                            "&& .MuiMenuItem-root:hover": {
                                backgroundColor: "#ffebee",
                                color: "#000"
                            }
                            } 
                        }}
                        >
                        {siteConfig.pageItems.map(({ title, key }) => (
                            <MenuItem value={key} key={key} className="font-primary">{title}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div> */}
            {/* <Typography className="font-primary mx-4 my-2 font-bold">ช่วงเวลาการแสดงผล</Typography> */}
            {/* <TimeRangeSetting /> */}
            {/* <Typography className="font-primary mx-4 my-2 font-bold">พื้นที่การแสดงผล</Typography> */}
            {/* <AreaSetting /> */}
        </div>
    )

    const toggleDrawerShowData = () => (event) => {
        dispatch(setMapDataSelected({}));
        setOpenShowData(!openShowData)
    };

    const contentShowData = (
        <DataShow />
    );

    // console.log(profile);

    if (profile) {
        return (
            <Box sx={{ display: 'flex', overflow: 'hidden', height: '100vh' }}>
                <CssBaseline />
                <AppBar position="fixed" open={open}>
                    <Toolbar
                        className='bg-white bg-gradient-to-bl from-blue-50 via-gray-100 to-slate-50'
                        sx={{
                            height: '60px'
                        }}
                    >
                        <Box display='flex' flexGrow={1}>
                            <IconButton
                                color="blue-gray"
                                aria-label="open drawer"
                                onClick={toggleDrawer}
                                edge="start"
                                sx={{
                                    zIndex: 1,
                                    mr: 2, ...(open && { display: 'none' })
                                }}
                            >
                                <MenuIcon />
                            </IconButton>
                            {/* <img 
                                    className="h-6 w-6 my-1.5" alt="candice" 
                                    src="/images/Watch-Logo-Color.png"
                                /> */}
                            <Box
                                component='img'
                                className="h-6 w-6 my-1.5"
                                alt="candice"
                                src="/images/Watch-Logo-Color.png"
                                sx={(theme) => ({
                                    [theme.breakpoints.down("sm")]: {
                                        display: 'none'
                                    },
                                })}
                            />
                            <Typography
                                as="a"
                                href="#"
                                className="mr-4 ml-2 cursor-pointer py-1.5 text-black font-bold font-primary tracking-wide text-xl"
                                sx={(theme) => ({
                                    [theme.breakpoints.down("sm")]: {
                                        display: 'none'
                                    },
                                })}
                            >
                                ทันระบาด<span className="text-blue-600">ติดตาม</span>
                            </Typography>
                        </Box>
                        <DiseaseList />
                        <IconButton
                            size="large"
                            aria-label="show 17 new notifications"
                            color="primary"
                            // sx={{
                            //     position: 'absolute',
                            //     right: 74
                            // }}
                            onClick={handleApps}
                        >
                            <Apps id="apps" className="h-6 w-6 text-lg" />
    
                        </IconButton>
                        <Menu
                            id="apps-appbar"
                            anchorEl={appsAnchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(appsAnchorEl)}
                            onClose={handleAppsClose}
                        >
                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                {profile.apps.map((item, idx) => (
                                    <div key={item.client_name}>
                                        <ListItem key={item.client_name} disablePadding alignItems="flex-start">
                                            <ListItemButton component="a" href={item.redirect_urls.split(",")[0]}>
                                                <ListItemAvatar>
                                                    {item.logo_url === "" ?
                                                        (<Avatar className='bg-deep-orange-700 font-primary p-2' src={item.logo_url}>
                                                            {item.client_name[0].toUpperCase()}
                                                        </Avatar>)
                                                        : (<img className='w-10 h-auto' alt={item.client_name} src={item.logo_url} />)}
    
    
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={item.is_default === 0 ? (<span>{item.client_name}<VerifiedUserIcon color="success" fontSize="small" className='pl-1 pb-1' /></span>) : (item.client_name)}
                                                    secondary={item.description} />
                                            </ListItemButton>
                                        </ListItem>
                                        {idx < profile.apps.length - 1 && <Divider />}
                                    </div>
                                ))}
                            </List>
                        </Menu>
                        <IconButton
                            color="primary"
                            // sx={{
                            //     position: 'absolute',
                            //     right: 24
                            // }}
                            onClick={handleMenu}
                        >
                            {/* <Badge badgeContent={4} color="secondary"> */}
                            <AccountCircleIcon />
                            {/* </Badge> */}
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            sx={(theme) => ({
                                '& .MuiMenu-list': {
                                    padding: 0
                                }
                            })}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <div className="w-80">
                                <CardHeader floated={false} className="h-fit">
                                    <img src={"/images/" + profile?.gender + ".jpg"} alt="profile-picture" />
                                </CardHeader>
                                <CardBody className="text-center">
                                    <Typography variant="h5" className="mb-2 font-primary text-blue-600">
                                        {profile?.displayName}
                                    </Typography>
                                    <Typography color="blue-gray" className="font-medium font-primary">
                                        {profile?.org_name}
                                    </Typography>
                                    <Typography color="blue-gray" className="font-medium font-primary text-sm">
                                        {profile?.mail}
                                    </Typography>
                                    <a href={dotenv.IAAM_HOST} className="inline-block mt-2">
                                        <Button size="sm" variant="text" className="w-full flex items-center gap-2 font-primary text-base">
                                            จัดการโพรไฟล์
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth={2}
                                                stroke="currentColor"
                                                className="h-4 w-4"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                                                />
                                            </svg>
                                        </Button>
                                    </a>
                                </CardBody>
                                <CardFooter className="pt-0">
                                    <Button
                                        // ripple={false}
                                        fullWidth={true}
                                        onClick={() => {
                                            if (iaam) {
                                                iaam.logout();
                                            }
                                        }}
                                        className="font-primary text-base bg-blue-gray-900/10 text-blue-gray-900 shadow-none hover:scale-105 hover:shadow-none focus:scale-105 focus:shadow-none active:scale-100"
                                    >
                                        ออกจากระบบ
                                    </Button>
                                </CardFooter>
                            </div>
                        </Menu>
                    </Toolbar>
                </AppBar>
                <Drawer
                    sx={(theme) => ({
                        width: drawerWidth,
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            [theme.breakpoints.up("sm")]: {
                                width: drawerWidth,
                            },
                            // width: drawerWidth,
                            boxSizing: 'border-box',
                        },
                    })}
                    // sx={{
                    //     width: drawerWidth,
                    //     flexShrink: 0,
                    //     '& .MuiDrawer-paper': {
                    //         width: drawerWidth,
                    //         boxSizing: 'border-box',
                    //     },
                    // }}
                    variant="persistent"
                    anchor="left"
                    open={open}
                >
                    {drawerItem}
                </Drawer>
                <SwipeableDrawer
                    anchor={'right'}
                    open={openShowData}
                    onClose={toggleDrawerShowData()}
                    onOpen={toggleDrawerShowData()}
                >
                    {contentShowData}
                </SwipeableDrawer>
                <Main open={open} className='p-0 mt-[60px] overflow-auto'>
                    <Suspense>
                        <Outlet />
                    </Suspense>
                </Main>
            </Box>
        );
    } else {
        return (
            <></>
        )
    }

    
}

export default Layout